var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.38 17.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nav"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.06,
    y1: 1.06,
    x2: 16.32,
    y2: 16.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1.06,
    y1: 16.32,
    x2: 16.32,
    y2: 1.06
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileX);
export default __webpack_public_path__ + "static/media/MOBILE-x.6d110ef67aaf0c2b8a88c21c9cdedcd9.svg";
export { ForwardRef as ReactComponent };